<template>
  <div class="pharmacies">
    <Loading v-if="loading" />
    <Title :title="$t('pharmacies')" />
    <Table :data="pharmacies" :columns="columns" @go-to-item="infoPharmacy" />
  </div>
</template>

<script lang="ts">
import { Vue, Options } from 'vue-class-component';

import Loading from '@/views/Loading.vue';

import { columns } from './configs';

@Options({
  name: 'Pharmacies',
  components: {
    Loading
  },
  data() {
    return {
      loading: false,
      pharmacies: [
        {
          name: 'Test',
          email: 'test@test.com',
          id: '123231212'
        },
        {
          name: 'Test2',
          email: 'test@test.com',
          id: '123231212'
        },
        {
          name: 'Test3',
          email: 'test@test.com',
          id: '123231212'
        },
        {
          name: 'Test4',
          email: 'test@test.com',
          id: '123231212'
        },
        {
          name: 'Test5',
          email: 'test@test.com',
          id: '123231212'
        },
        {
          name: 'Test6',
          email: 'test@test.com',
          id: '123231212'
        },
        {
          name: 'Test7',
          email: 'test@test.com',
          id: '123231212'
        },
        {
          name: 'Test8',
          email: 'test@test.com',
          id: '123231212'
        },
        {
          name: 'Test9',
          email: 'test@test.com',
          id: '123231212'
        },
        {
          name: 'Test10',
          email: 'test@test.com',
          id: '123231212'
        },
        {
          name: 'Test11',
          email: 'test@test.com',
          id: '123231212'
        },
        {
          name: 'Test12',
          email: 'test@test.com',
          id: '123231212'
        }
      ],
      columns: columns(this.$t)
    };
  },
  methods: {
    infoPharmacy(id: string) {
      console.log('id', id);
      //  router.push({ name: 'InfoUser', params: { id } });
    }
  }
})
export default class Pharmacies extends Vue {}
</script>

<style lang="scss" scoped>
.pharmacies {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 50px);
  padding: 24px;
  overflow-y: scroll;
  overflow-x: hidden;
}
</style>
